export const MS_ADL_ACTIVITY_KEYS = [
    "Walking",
    "Cooking",
    "Driving",
    "Shopping",
    "Work",
    "Sport",
    "Housework",
    "Socialising",
] as const;

export type MsAdlActivityKey = (typeof MS_ADL_ACTIVITY_KEYS)[number];

export type MsAdlActivityLabels = Record<MsAdlActivityKey, string>;

export const msAdlCopyEn: MsAdlActivityLabels = {
    Walking: "Walking",
    Cooking: "Cooking",
    Driving: "Driving",
    Shopping: "Shopping",
    Work: "Work",
    Sport: "Sport",
    Housework: "Housework",
    Socialising: "Socialising",
};
